module.exports = __webpack_public_path__ + "img/click-to-unlock-nissan-button.01a2cabe.gif";